exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notPermission {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  gap: 1rem;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100%; }\n\n.table__header {\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 2rem; }\n  .table__header input {\n    max-width: 500px; }\n\n.button__wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: end;\n  gap: 0.75rem;\n  margin-top: 5px; }\n\n.modal {\n  background: rgba(0, 0, 0, 0.4); }\n  .modal .modal-body {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    gap: 1rem; }\n\nmat-drawer p button {\n  max-width: 250px;\n  width: 200px; }\n\nspan {\n  font-size: 12px;\n  font: Poppins;\n  color: #607d8b; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/edit-global-types/edit-global-types.component.scss
// module id = ../../../../../src/app/components/edit-global-types/edit-global-types.component.scss
// module chunks = main